export default __webpack_public_path__ + "static/media/Guerrilla-White-LOGO.78edc22a.png";